import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './KBHCurriculum.module.css';
import { createApiUrl } from '../utils/apiConfig';

const KBHCurriculum = () => {
  const [resources, setResources] = useState([]);

  useEffect(() => {
    const fetchResources = async () => {
      try {
        const response = await axios.get(createApiUrl('/api/kbh-curriculum'), {
          headers: {
            'Accept': 'application/json'
          },
          withCredentials: true
        });
        setResources(response.data.resources || []);
      } catch (error) {
        console.error('Error fetching resources:', error);
      }
    };
    fetchResources();
  }, []);

  return (
    <div className={styles.kbhCurriculumPage}>
      <img src="/img/resources_image.png" alt="Page header" className={styles.topImage} />
      <div><p></p></div>

      <section className={styles.overviewSection}>
        <h1 className={styles.kbhCurriculumTitle}>Overview</h1>
        <p>
          At KBH Classroom, we've carefully crafted our lessons to align with the KS2 curriculum, making it easy for teachers to incorporate black history into their classrooms. Each 40-minute video lesson connects directly to subjects like History, Geography, Science, and English, ensuring students meet curriculum goals while gaining a deeper understanding of black historical figures, cultures, and contributions. Our lessons not only enrich students' learning but also foster critical thinking, empathy, and cultural awareness. With our peer-to-peer teaching approach, led by our 8-year-old teacher, students are engaged and inspired, making KBH Classroom the perfect fit for KS2 educators looking to bring diverse and inclusive education to life.
        </p>
        <div className={styles.imageContainer}>
          <img src="/img/resources1.png" alt="Resources section" className={styles.imageFluid} />
        </div>
        <br />
      </section>

      <section className={styles.lessonSection}>
        <h1 className={styles.kbhCurriculumTitle}>Lesson Structure</h1>
        <p>
          Each lesson is structured to include a video, a quiz, and a set of resources. The video is the main teaching tool, providing an engaging and interactive way to learn about historical events and figures. The quiz is designed to test pupils' knowledge and understanding of the lesson content, while the resources provide additional information and activities to support learning.
        </p>
        <div className={styles.videoSection}>
          <iframe
            src="https://www.youtube.com/embed/7RD7BER0rsQ"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Introducing KBH Classroom"
            className={styles.videoIframe}
          />
        </div>
          <h6 className={styles.videoHeading}>
            Introducing KBH Classroom – Revolutionizing Black History Education for Schools Worldwide</h6>
        <p>
          Our lessons are designed to be flexible, allowing teachers to adapt them to suit their students' needs and learning styles.
        </p>
      </section>

      <section className={styles.resourcesSection}>
        <h1 className={styles.kbhCurriculumTitle}>Resources</h1>
        <div className={styles.resourceList}>
          {resources.map((resource, _index) => (
            <div key={resource.key} className={styles.listGroupItem}>
              <a href={resource.url} target="_blank" rel="noopener noreferrer" className={styles.resourceButton}>
                {resource.key.replace('.pdf', '')}
                <img src="/img/pdf-icon.png" alt="PDF" className={styles.pdfIcon} />
              </a>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default KBHCurriculum; 